/**
 * Badge de "charla privada" (incógnito) visible durante toda la sesión mientras
 * el modo esté activo. Da certeza al user de que nada de lo que hable se guarda
 * (ni en memoria ni en historial). Portado del diseño v4 (conv-private-bar).
 */
export function PrivateBadge() {
  return (
    <div className="conv-private-bar">
      <div className="conv-private-badge">
        <span className="ic" aria-hidden>
          <svg viewBox="0 0 24 24" width={14} height={14} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 4 L 20 20" />
            <path d="M9.5 5.4 A 9 9 0 0 1 12 5 c 5 0 9 5 9 7 a 11 11 0 0 1 -2 2.6" />
            <path d="M6.2 7.3 C 4 8.8 3 11 3 12 c 0 2, 4 7, 9 7 a 9 9 0 0 0 3 -0.5" />
            <path d="M9.9 9.9 A 3 3 0 0 0 14 14.1" />
          </svg>
        </span>
        Charla privada · no guardo nada de esto
        <span className="pulse" />
      </div>
    </div>
  );
}
